import { OfferLookupEntityOption } from '../Utils/offerLookupAddNew';

export interface OfferCountryLookupSource {
  id: number;
  name?: string | null;
}

export interface OfferRegionLookupSource {
  id: number;
  name?: string | null;
}

export interface OfferHotelLookupSource {
  id: number;
  name?: string | null;
  city?: string | null;
}

export const mapCountryToOfferLookupOption = (
  country: OfferCountryLookupSource | undefined | null
): OfferLookupEntityOption | undefined => {
  const id = toPositiveInt(country?.id);
  if (!id) {
    return undefined;
  }

  const name = normalizeText(country?.name);
  if (!name) {
    return undefined;
  }

  return {
    value: id,
    label: name,
  };
};

export const mapRegionToOfferLookupOption = (
  region: OfferRegionLookupSource | undefined | null
): OfferLookupEntityOption | undefined => {
  const id = toPositiveInt(region?.id);
  if (!id) {
    return undefined;
  }

  const name = normalizeText(region?.name);
  if (!name) {
    return undefined;
  }

  return {
    value: id,
    label: name,
  };
};

export const mapHotelToOfferLookupOption = (
  hotel: OfferHotelLookupSource | undefined | null
): OfferLookupEntityOption | undefined => {
  const id = toPositiveInt(hotel?.id);
  if (!id) {
    return undefined;
  }

  const name = normalizeText(hotel?.name);
  if (!name) {
    return undefined;
  }

  const city = normalizeText(hotel?.city);

  return {
    value: id,
    label: city ? `${name} • ${city}` : name,
  };
};

type IdCandidate = string | [string, string];

export const extractCreatedLookupId = (
  source: unknown,
  candidates: IdCandidate[]
): number | undefined => {
  if (!source || typeof source !== 'object') {
    return undefined;
  }

  const record = source as Record<string, unknown>;

  for (const candidate of candidates) {
    if (typeof candidate === 'string') {
      const id = toPositiveInt(record[candidate]);
      if (id) {
        return id;
      }
      continue;
    }

    const [outerKey, innerKey] = candidate;
    const outerValue = record[outerKey];
    if (!outerValue || typeof outerValue !== 'object') {
      continue;
    }

    const nestedRecord = outerValue as Record<string, unknown>;
    const nestedId = toPositiveInt(nestedRecord[innerKey]);
    if (nestedId) {
      return nestedId;
    }
  }

  return undefined;
};

function toPositiveInt(value: unknown): number | undefined {
  const parsed = Number(value);
  if (Number.isInteger(parsed) && parsed > 0) {
    return parsed;
  }

  return undefined;
}

function normalizeText(value: string | null | undefined): string {
  return value?.trim() ?? '';
}
